@for (section of sections; track $index) {
  <mat-card class="faq-card chart-card">

    @if (section.title) {
      <!-- <h3 class="section-title">{{ section.title }}</h3> -->
      <mat-toolbar class="chart-card-header-toolbar">
        <div class="right">
          <span class="chart-card-title">{{section.title}}</span>
        </div>
        <div class="left">
        </div>      
      </mat-toolbar>
    }

    <mat-card-content>
        
        <mat-accordion multi>
          @for (entry of section.entries; track entry.question) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>{{ entry.question }}</mat-panel-title>
              </mat-expansion-panel-header>
              @for (block of entry.blocks; track $index) {
                @if (block.label) {
                  <div class="block-label">{{ block.label }}</div>
                }
                @if (block.text) {
                  <p class="faq-answer" [innerHTML]="answerHtml(block.text)"></p>
                }
              }
            </mat-expansion-panel>
          }
        </mat-accordion>

    </mat-card-content>

  </mat-card>
}